'use strict';

/* global yith_wcaf */

import { $, labels } from '../../../src/globals.js';
import YITH_WCAF_Admin_Modal from './yith-wcaf-admin-modal';
import YITH_WCAF_Ajax from '../../../src/modules/ajax.js';

export default class YITH_WCAF_Add_Profile_Field_Modal extends YITH_WCAF_Admin_Modal {
	constructor( $opener, args ) {
		super( $opener, {
			template: 'yith-wcaf-add-affiliate-field-modal',
			title: ( data ) => {
				return data.name
					? labels?.edit_field_modal_title
					: labels?.add_field_modal_title;
			},
			data() {
				const $target = this.$target,
					$dataSource = $target?.closest( '[data-item]' );

				if ( ! $dataSource || ! $dataSource.length ) {
					return {};
				}

				return $dataSource.data( 'item' );
			},
			width: 550,
			...args,
		} );
	}

	initFields() {
		this.initOptionsTable();
		this.initCarbonCopyFields();

		super.initFields();
	}

	initOptionsTable() {
		const $content = this.modal.elements.content,
			$optionsTable = $content.find( '#options_table' );

		if ( ! $optionsTable.length ) {
			return;
		}

		// populate table with existing options.
		const data = this.getData(),
			options = data?.options;

		if ( options?.length ) {
			for ( const option of options ) {
				this.addOption( option );
			}
		} else {
			this.addOption( {} );
		}

		// init add button.
		$content.find( '#add_new_option' ).on( 'click', ( ev ) => {
			ev.preventDefault();

			this.addOption( {} );
		} );

		// init delete buttons.
		$optionsTable.on( 'click', '.delete', function ( ev ) {
			ev.preventDefault();

			$( this ).closest( 'tr' ).remove();
		} );

		// init drag&drop
		$optionsTable.find( 'tbody' ).sortable( {
			handle: '.drag',
		} );
	}

	addOption( option ) {
		const $content = this.modal.elements.content,
			optionsTable = $content.find( '#options_table' );

		if ( ! optionsTable.length ) {
			return;
		}

		let id = optionsTable.data( 'id' ) || 0;
		const row = wp.template( 'yith-wcaf-add-affiliate-field-option' )( {
			id: id++,
			...option,
		} );

		optionsTable.data( 'id', id ).find( 'tbody' ).append( row );
	}

	initCarbonCopyFields() {
		const self = this,
			$fields = this.getFields();

		$fields.on( 'keydown', function () {
			const $field = $( this ),
				$copy_fields = $fields.filter( '[data-copy-target]' ),
				value = $field.val();

			$copy_fields.each( function () {
				const $copy_field = $( this ),
					target = $copy_field.data( 'copy-target' ),
					$target = $( target, self.modal.elements.content );

				if ( ! $target.length || ! $target.is( $field ) ) {
					return;
				}

				const currentValue = $copy_field.val();

				if ( ! currentValue || currentValue === value ) {
					setTimeout( () => {
						$copy_field.val( $field.val() );
					}, 100 );
				}
			} );
		} );
	}

	onSubmit() {
		const $content = this.modal.elements.content;

		if ( ! this.beforeSubmit() ) {
			return false;
		}

		this.hideErrorMessage();

		YITH_WCAF_Ajax.post
			.call(
				$content,
				'save_affiliate_profile_field',
				'save_profile_field',
				{
					field_name: this.getField( 'prev_name' ).val(),
					field: this.serialize(),
				}
			)
			.done( ( data ) => {
				if ( 'function' === typeof this.args?.onSubmitSuccess ) {
					this.args?.onSubmitSuccess( data?.data );
				}

				if ( data?.success ) {
					this.modal.close();
				} else if ( data?.data?.message ) {
					this.showErrorMessage( data.data.message );
				}
			} );

		return false;
	}
}
